import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

import {
  authErrorsSelector,
  createUser,
  isLoadingSignupSelector,
  setAuthErrors,
} from 'src/store/auth';

import {
  CustomButton,
  CustomCheckbox,
  CustomInput,
  CustomLink,
  PageLoader,
  WhiteCard,
} from 'src/components';

import { ROUTE } from 'src/constants';

import './signUp.scss';

export const SignUp = () => {
  const { t } = useTranslation('auth');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formError = useSelector(authErrorsSelector);
  const isLoading = useSelector(isLoadingSignupSelector);

  const [formData, setFormData] = useState({
    login: '',
    email: '',
    password: '',
    password_confirmation: '',
  });

  useEffect(() => {
    dispatch(setAuthErrors({}));
  }, [dispatch]);

  const onClickEnter = useCallback(() => {
    navigate(ROUTE.AUTH.SIGN_IN);
  }, [navigate]);

  const onSubmit = useCallback(
    (event) => {
      event.preventDefault();

      const payload = {
        payload: formData,
        navigate,
      };

      dispatch(createUser(payload));

      setTimeout(() => {
        document.getElementById('login')?.focus();
      }, 500);
    },
    [dispatch, navigate, formData],
  );

  const onChange = useCallback(
    (key) => (event) => {
      setFormData((prev) => ({ ...prev, [key]: event.target.value }));

      const copiedErrors = _.cloneDeep(formError);
      delete copiedErrors[key];

      dispatch(setAuthErrors(copiedErrors));
    },
    [dispatch, formError],
  );

  return (
    <div className="sign-up">
      {isLoading && <PageLoader />}

      <WhiteCard>
        <h2>
          {t('signUp')}
          <CustomButton title={t('enter')} color="green" onClick={onClickEnter} />
        </h2>
        <form className="sign-up__form" onSubmit={onSubmit} autoComplete="on">
          <CustomInput
            label={t('login')}
            value={formData.login}
            onChange={onChange('login')}
            errorMessage={formError?.login}
            name="username"
            autoComplete="username"
            id="login"
          />
          <CustomInput
            label={t('email')}
            value={formData.email}
            onChange={onChange('email')}
            errorMessage={formError?.email}
            name="email"
            autoComplete="off"
          />
          <CustomInput
            label={t('password')}
            value={formData.password}
            type="password"
            onChange={onChange('password')}
            errorMessage={formError?.password}
            name="password"
            autoComplete="current-password"
            id="password"
          />
          <CustomInput
            label={t('confirmPassword')}
            value={formData.password_confirmation}
            type="password"
            onChange={onChange('password_confirmation')}
            errorMessage={formError?.password_confirmation}
            name="confirm-password"
            autoComplete="off"
          />

          <div className="sign-up__form__footer">
            <CustomCheckbox />
            <span>
              {t('registering')} <CustomLink title={t('rules')} /> {t('and')}{' '}
              <CustomLink title={t('politics')} />
            </span>
          </div>

          <CustomButton type="submit" title={t('signUp')} variant="filled" />
        </form>
      </WhiteCard>
    </div>
  );
};
